import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, FontWeight, Media, Layer } from '../../theme';
import { hexToRgba, styleWhenTrue } from '../../utils';
import { FullscreenPhotoContainerData, ArrowContainerData } from './dynamicContentComponent.types';
import { SectionContainer } from '../../uiComponents';

export const TextContent = styled.div`
  word-break: break-word;
  color: ${Color.darkGrey};
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 32px;
   p + p {
     margin-top: 32px;
   }
   a {
     color: ${Color.primary};
     text-decoration: none;
   }
   strong {
     font-weight: ${FontWeight.Medium};
   }
   li {
     margin-top: 20px;
     padding-left: 25px;
     position: relative;
     .bullet {
       height: 6px;
       width: 6px;
       border-radius: 50%;
       background-color: ${Color.primary};
       display: block;
       position: absolute;
       left: 0;
       top: 13px;
     }
   }
`;

export const Photo = styled.img`
  width: 100%;
`;

export const SliderPhoto = styled.img`
  width: 100%;
  cursor: pointer;
`;

export const ArrowContainer = styled.button<ArrowContainerData>`
  position: absolute;
  left: -32px;
  top: 50%;
  transform: translateY(-50%);
  height: 64px;
  width: 64px;
  background-color: ${Color.primary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.7s;
  ${Media.tablet`
    display: none;
  `}
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const LeftArrowContainer = styled(ArrowContainer)``;

export const RightArrowContainer = styled(ArrowContainer)`
  left: auto;
  right: -32px;
`;

export const LeftArrow = styled.img`
  width: 20px;
`;

export const RightArrow = styled.img`
  width: 20px;
  transform: rotate(180deg);
`;

export const GalleryContainer = styled.div`
  position: relative;
`;

export const FullscreenPhotoContainer = styled.div<FullscreenPhotoContainerData>`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: ${hexToRgba(Color.black, 0.7)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Layer.PhotoGalleryPopup};
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.7s;
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const FullscreenPhoto = styled.img`
  max-height: calc(100% - 140px);
  max-width: calc(100% - 140px);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
`;

export const CloseIcon = styled.img``;

export const ClassicButtonStyle = `
  padding: 20px 30px;
  margin-top: 40px;
  max-width: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Color.mediumLightGrey};
  background-color: ${Color.white};
  text-decoration: none;
  color: ${Color.darkGrey};
  font-size: 15px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: 0;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.7;
  }
`;

export const ClassicButton = styled.div`
  a {
    ${ClassicButtonStyle}
  }
`;

export const ActionButton = styled(ClassicButton)`
  a {
    box-shadow: 0 2px 10px 0 ${hexToRgba(Color.primary, 0.25)};
    background-color: ${Color.primary};
    color: ${Color.white};
  }
`;

export const Video = styled.video``;

export const AddToComparisonButton = styled.button`
  ${ClassicButtonStyle}
  &:disabled {
    background-color: ${Color.veryLightGrey} !important;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  button + div {
    margin-left: 20px;
  }
`;

export const LocalSectionContainer = styled(SectionContainer)`
  .content-container {
    img + img,
    img + div,
    img + video,
    img + .numeric-list,
    img + .table-section,
    img + .gallery-container,
    img + .counter-section,
    img + .text-content,

    div + img,
    div + video,
    div + .numeric-list,
    div + .table-section,
    div + .gallery-container,
    div + .counter-section,
    div + .text-content,

    video + video,
    video + img,
    video + div,
    video + .numeric-list,
    video + .table-section,
    video + .gallery-container,
    video + .counter-section,
    video + .text-content,

    .numeric-list + .numeric-list,
    .numeric-list + div,
    .numeric-list + img,
    .numeric-list + video,
    .numeric-list + .table-section,
    .numeric-list + .gallery-container,
    .numeric-list + .counter-section,
    .numeric-list + .text-content,

    .table-section + .table-section,
    .table-section + div,
    .table-section + img,
    .table-section + video,
    .table-section + .numeric-list,
    .table-section + .gallery-container,
    .table-section + .counter-section,
    .table-section + .text-content,

    .counter-section + .counter-section,
    .counter-section + div,
    .counter-section + img,
    .counter-section + video,
    .counter-section + .numeric-list,
    .counter-section + .gallery-container,
    .counter-section + .counter-section,
    .counter-section + .text-content,

    .text-content + .text-content,
    .text-content + div,
    .text-content + img,
    .text-content + video,
    .text-content + .numeric-list,
    .text-content + .gallery-container,
    .text-content + .table-section,
    .text-content + .counter-section,

    .gallery-container + .gallery-container,
    .gallery-container + div,
    .gallery-container + img,
    .gallery-container + video,
    .gallery-container + .table-section,
    .gallery-container + .numeric-list,
    .gallery-container + .counter-section
    .gallery-container + .text-content {
      margin-top: 32px;
    }
  }
`;
